import { AxiosError } from 'axios';
import { Auth, IAuthResponse } from '../Auth';
import { AuthProvider } from './AuthProvider';

export type SsoAuthParameter = {
  cipher: string;
  hash: string;
  authgroup: string;
};
export class SsoLogin extends AuthProvider<SsoAuthParameter> {
  constructor(auth: Auth) {
    super(auth);
  }

  public login(credentials: SsoAuthParameter): Promise<boolean> {
    this.validateConfig();
    const startTime = Date.now();
    return this.auth
      .request({
        url: `/sessions/trustedlogin?cipherToken=${encodeURIComponent(
          credentials.cipher
        )}&hashToken=${encodeURIComponent(credentials.hash)}&authGroup=${
          credentials.authgroup
        }&fetchToken=true`,
        method: 'get',
      })
      .then((response: IAuthResponse) => {
        return this.createSession(response, null, Date.now() - startTime, true);
      })
      .then((sessionObj) => {
        return this.getTokenFromCredentials(sessionObj);
      })
      .then(() => true)
      .catch((error: AxiosError) => {
        this.logout();
        return Promise.reject(error);
      });
  }
}
